<template>
  <main>
    <div v-if="currentFluxer[0]" class="reporte-objetivos">
      <headerFeed :currentUser="currentUser" title="Reportes de Objetivos"></headerFeed>
      <md-spinner v-show="loader" md-indeterminate></md-spinner>
      <md-table v-if="currentFluxer[0].admin">
        <md-table-header>
            <md-table-row>
                <md-table-head>Dueño</md-table-head>
                <md-table-head>Lider</md-table-head>
                <md-table-head>Fecha de creacion</md-table-head>
                <md-table-head>Acuerdo vigente</md-table-head>
                <md-table-head>Acuerdo finalizado</md-table-head>
            </md-table-row>
        </md-table-header>

        <md-table-body>
            <md-table-row @click.native="openDetail(acuerdo)" v-for="(acuerdo, index) in allAcuerdos" :key="index">
                <md-table-cell>{{acuerdo.owner}}</md-table-cell>
                <md-table-cell>{{acuerdo.editor}}</md-table-cell>
                <md-table-cell>{{acuerdo.created | moment("YYYY/MM/DD HH:mm")}}</md-table-cell>                
                <md-table-cell v-if="acuerdo.sent">{{acuerdo.sent | moment("YYYY/MM/DD HH:mm")}}</md-table-cell>
                <md-table-cell v-else>-</md-table-cell>                                
                <md-table-cell v-if="acuerdo.finalizado">{{acuerdo.finalizado | moment("YYYY/MM/DD HH:mm")}}</md-table-cell>
                <md-table-cell v-else>-</md-table-cell>
            </md-table-row>
        </md-table-body>
      </md-table>
    </div>
  
    <div v-else>
        Necesita ser Administrador de la app para ver esta seccion
    </div>

    <router-view></router-view>

  </main>
</template>

<script>

import header from './Header'
import _ from 'lodash'
import Router from '../router'
import FluxerService from '../services/fluxer'
import ObjetivosService from '../services/objetivos'

export default {
  name: 'reporte-objetivos',
  components: {
    'headerFeed': header
  },
  data () {
    return {
      loader: false,
      currentUser: FluxerService.getCurrentUser()
    }
  },
  firebase: function () {
    this.loader = true
    return {
      allAcuerdos: {
        source: ObjetivosService.getAll(),
        readyCallback: function () {
          this.loader = false
        }
      },
      allFluxers: FluxerService.getAll(),
      currentFluxer: FluxerService.getFluxerByEmail(this.currentUser.email)
    }
  },
  methods: {
    openDetail (acuerdo) {
      let fluxerObjectSelect = _.find(this.allFluxers, function (o) { return o.email === acuerdo.owner })
      Router.push({name: 'acuerdo-detail-reporte', params: {id: acuerdo['.key'], fluxerSelected: fluxerObjectSelect}})
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="sass">
@import "../sass/variables.scss"

.md-table .md-table-head-container { text-align: center; }

table { margin-top: 60px }

</style>



// WEBPACK FOOTER //
// ReporteObjetivos.vue?ed6968ea